import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b3ddf28"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "data-testid", "checked", "disabled"]

import { HTMLInputEvent } from '@/typings/html-input-events'

type Props = {
  isChecked?: boolean
  isDisabled?: boolean
  name: string
}

type Emits = {
  (event: 'on-change', isChecked: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
    isChecked: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    name: { default: undefined }
  },
  emits: ["on-change"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit



const handleChange = (event: Event) => {
  const checked = (event as HTMLInputEvent).target?.checked
  emits('on-change', checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.name + '-switch',
    class: _normalizeClass(["switch-label", `${_ctx.isChecked ? 'checked' : ''} ${_ctx.isDisabled ? 'is-disabled' : ''}`])
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      id: _ctx.name + '-switch',
      "data-testid": _ctx.name + '-input',
      checked: _ctx.isChecked,
      disabled: _ctx.isDisabled,
      onChange: handleChange
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})